import React from 'react';
export function UrgencyBanner() {
  return <div className="bg-amber-600 text-white py-3 px-4 text-center sticky top-0 z-50 shadow-md" data-id="element-196">
      <p className="text-sm md:text-base font-bold tracking-wide" data-id="element-197">
        <span className="animate-pulse mr-2" data-id="element-198">🔥</span>
        OFERTA ESPECIAL: Precio de lanzamiento $6.39 USD (antes $19). Esta
        oferta puede terminar en cualquier momento.
      </p>
    </div>;
}